import React from 'react';
import VenteList from '../../components/vente_list/VenteListContainer';

export default function VenteListChargePage() {
  React.useEffect(() => {
    document.title = "Shems Almadina - Modification des chargés des biens"
    return () => {
      document.title = "Shems Almadina"
    };
  }, []);
  return (
    <VenteList isCharge={true} />
  );
}
